import React, { useContext, useEffect, useState, useRef, Fragment } from 'react';
import { useParams, Link } from "react-router-dom";

import ModuleCheckbox from '../components/ModuleCheckbox';
import ModuleDocument from '../components/ModuleDocument';
import CheckboxField from '../components/CheckboxField';
import UploadField from '../components/UploadField';
import { get, useForm } from 'react-hook-form';

import { PDFExport, savePDF } from '@progress/kendo-react-pdf';

import { AppContext } from '../../App';
import { getMediaFilePath } from '../../functions/get-media-file-path';
import { generateId } from '../../functions/generate-id';

const AssessmentDocument = ({ course, courseStudent, assessment, courseModuleId, hasFellowAccess }) => {
  const { register, handleSubmit, setValue, watch, reset, formState: { errors } } = useForm();
  const appContext = useContext(AppContext);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [confirmOriginal, setConfirmOriginal] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploading, setUploading] = useState(false);
  console.log(assessment)
  console.log(courseStudent)

  const selectedModule = courseStudent?.selectedModules?.find(m => m.courseModuleId == courseModuleId);
  //console.log(selectedModule.moduleRequirementCodeName)
  //console.log(courseModuleId);
  //console.log("courseModuleAssessmentId", assessment?.courseModuleAssessmentId);

  // Helper to get the latest valid studentAssessment
  
  const getLatestStudentAssessment = (assessments, courseModuleAssessmentId) => {
    const matches = assessments.filter(sa => sa.courseModuleAssessmentId == courseModuleAssessmentId);
    const validMatches = matches.filter(m => m.assessmentPaperId);
    const latest = validMatches.reduce((prev, curr) => {
      return (!prev || curr.assessmentPaperId > prev.assessmentPaperId) ? curr : prev;
    }, null) || matches[0] || {};
    return latest;
  };

  const [studentAssessment, setStudentAssessment] = useState(() => {
    if (hasFellowAccess) return null;
    return getLatestStudentAssessment(courseStudent?.assessments, assessment.courseModuleAssessmentId);
  });

  useEffect(() => {
    if (hasFellowAccess) return;
    const newStudentAssessment = getLatestStudentAssessment(courseStudent?.assessments, assessment.courseModuleAssessmentId);
    setStudentAssessment(newStudentAssessment);
  }, [hasFellowAccess, courseStudent, assessment]);

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const handleUploadAssessment = async (data) => {
    console.log("Selected file:", data.assessment.file);
    const selectedFile = data.assessment.file;
    if (!selectedFile) return;

    setUploading(true);
  
    try {
      const response = await appContext.httpClient.post({
        path: "assessment/submit",
        body: {
          courseModuleAssessmentId: assessment.courseModuleAssessmentId,
          assessmentPaper: selectedFile,
          courseStudentId: courseStudent?.courseStudentId
        }
      });

      //debugger;
      
      console.log("Upload response:", response); // Check response here
      if (response.success) {
        reset({
          assessment: response.result
        });
        setStudentAssessment(response.result);
        setUploadSuccess(true);
        setIsFileSelected(false);
      } else {
        console.error("Upload failed - response.success was false");
      }
    } catch (error) {
      console.error("Upload failed:", error); // Log errors
    } finally {
      setUploading(false);
    }
  };

  const handleFileChange = (event) => {
    if (event.target.info?.succeeded && event.target.info?.filename) {
      setIsFileSelected(true);
    } else {
      setIsFileSelected(false);
    }
    setUploadSuccess(false);
  };

  console.log(studentAssessment)

  const handleConfirmOriginal = (e) => {
    setConfirmOriginal(e.target.checked);
  };

  const ensureDate = (dateString) => {
    if (!dateString) return null; // Return null if no date string is provided
    const parsedDate = new Date(dateString);
    return isNaN(parsedDate.getTime()) ? null : parsedDate; // Ensure it's a valid date
  }  

  return (
    <div className="flex flex-col relative mb-12">
      <div className="w-full p-6 bg-brandDarkBlue">
          <h2 className="section-title text-1xl text-white font-bold">{assessment.assessmentTitle}</h2>
      </div>
      <form onSubmit={handleSubmit(handleUploadAssessment)}>
        <div className="py-6 px-6 bg-white">
          {assessment.file && (
            <ModuleDocument
              name={assessment.file.filename}
              type={assessment.file.fileExtension.replace('.', '')}
              link={`https://insol.azureedge.net/cmsstorage/insol/media/education/${assessment.file.path.toLowerCase()}`}
            />
          )}
          {!hasFellowAccess && (
          <>
          <h3 className="text-brandMidBlue text-lg font-bold mb-4 block">Your uploaded assessment</h3>

          {(() => {
            const now = new Date();
            const deadline = ensureDate(
              courseStudent?.yearsToComplete === 2
                ? (
                    selectedModule?.moduleRequirementCodeName === "compulsory" ||
                    selectedModule?.moduleRequirementCodeName === "ab-compulsory" &&
                    selectedModule?.isElective === false
                  )
                    ? assessment.year1DeadlineWithTZ
                    : assessment.year2DeadlineWithTZ
                : assessment.year1DeadlineWithTZ
            );
            
            const isPastDeadline = now > deadline;

            return isPastDeadline ? (
              <>
                <UploadField 
                    key={assessment.courseModuleAssessmentId}
                    name={`assessment.file`}
                    setValue={setValue}
                    register={register}
                    defaultFile={{
                      ...studentAssessment,
                      type: studentAssessment.resubmittedAssessmentPaper ? "RESUBMITTED_PAPER" : "PAPER"
                    }}
                    onChange={handleFileChange}
                    disabled={true}
                />
                <button
                  type="button"
                  className="border-2 border-brandDarkBlue text-brandDarkBlue font-medium py-2 px-6 rounded-md self-start cursor-default"
                  style={{ border: '2px solid #172B46 !important' }}
                >
                  Sorry, the deadline for this assessment has passed
                </button>
              </>
            ) : (
              <>
                <UploadField 
                    key={assessment.courseModuleAssessmentId}
                    name={`assessment.file`}
                    setValue={setValue}
                    register={register}
                    defaultFile={{
                      ...studentAssessment,
                      type: studentAssessment.resubmittedAssessmentPaper ? "RESUBMITTED_PAPER" : "PAPER"
                    }}
                    onChange={handleFileChange}
                    disabled={!!studentAssessment?.assessmentPaperId}
                />
                <CheckboxField
                    label="I confirm that this submission is my own original work and has not been plagiarised."
                    name="confirmOriginal"
                    type="checkbox"
                    onChange={handleConfirmOriginal}
                />
                {uploadSuccess && (
                  <div className="flex items-center bg-green p-3  text-sm mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-3" viewBox="0 0 16 16">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                    </svg>
                    <span>Assessment upload successful</span>
                  </div>
                )}
                <button
                  disabled={!isFileSelected && !confirmOriginal}
                  className={`
                    ${isFileSelected && confirmOriginal ? "bg-brandRed" : "bg-brandGrey"}
                    ${uploading ? "opacity-70 cursor-not-allowed" : "hover:bg-blue-700"} 
                    hover:bg-blue-700 text-white font-medium py-2 px-6 mb-6 rounded-md self-start w-full`}
                  >
                  {uploading ? "Saving..." : "Save document"}
                </button>
              </>
            );
          })()}
          
          {studentAssessment && studentAssessment.markedPaper && (
          <div className="mb-3">
            <h3 className="text-brandMidBlue text-lg font-bold mb-4 block">Your marked assessment</h3>
            {studentAssessment && studentAssessment.markedPaper && studentAssessment.markedPaper.path ? (
                <>
                  <a className="flex bg-uiUpload p-3 text-xs border-solid border border-uiUploadBorder text-kenticoblue underline" href={`${getMediaFilePath(studentAssessment, "MARKED_PAPER").url}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-3" viewBox="0 0 16 16">
                    <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                  </svg>
                    View your marked assessment
                  </a>
                </>
            ) : null}
            {studentAssessment && studentAssessment.resubmittedAssessmentPaper && studentAssessment.resubmittedAssessmentPaper.path ? (
                <>
                  <a className="flex bg-uiUpload p-3 text-xs border-solid border border-uiUploadBorder text-kenticoblue underline" href={`${getMediaFilePath(studentAssessment, "RESUBMITTED_MARKED_PAPER")?.url}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-3" viewBox="0 0 16 16">
                    <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                  </svg>
                    View your resubmitted marked assessment
                  </a>
                </>
            ) : null}
          </div>
          )}
          </>
        )}
        </div>
        {courseStudent?.yearsToComplete === 2 ? (
          <div className="w-full p-3 bg-brandDarkBlue">
              <p className="text-white font-bold">Deadline: {selectedModule?.moduleRequirementCodeName === "compulsory" || selectedModule?.moduleRequirementCodeName === "ab-compulsory" && selectedModule?.isElective === false ? formatDate(assessment.year1Deadline) : formatDate(assessment.year2Deadline)}</p>
          </div>
        ) : (
          <div className="w-full p-3 bg-brandDarkBlue">
              <p className="text-white font-bold">Deadline: {formatDate(assessment.year1Deadline)}</p>
          </div>
        )}
      </form>
    </div>
  );
};

const Module = () => {
  const { courseId, moduleId } = useParams();
  const appContext = useContext(AppContext);
  
  const [course, setCourse] = useState([]);
  const [user, setUser] = useState(false)
  const [courseStudent, setCourseStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [courseModule, setCourseModule] = useState(null);
  const [isFellow, setIsFellow] = useState(false);
  const [fellowAccess, setFellowAccess] = useState(false);

  useEffect(() => {
    setLoading(true);

    // Fetch logged in user
    appContext.httpClient.get({
      path: "user"
    }).then(response => {
      if (response.result) {
        console.log(response.result)
        setUser(response.result);
        setIsFellow(response.result.isFellow);
      }
    })

    // Fetch course student data
    appContext.httpClient.post({
      path: "coursestudent",
      authRedirectPath: appContext.loginPath,
      body: {
        courseId
      }
    }).then(response => {
        console.log(response)
        if (response.success && response.result) {
            setCourseStudent(response.result);
            console.log("Course Student Data:", response.result);
        }
    });

    // Fetch course data
    appContext.httpClient.get({
      path: "course/" + courseId,
      authRedirectPath: appContext.loginPath
    }).then(response => {
        if (response.success && response.result) {
          const courseData = response.result;
          courseData.courseLogo = getMediaFilePath(courseData.courseLogo).url;
          courseData.courseBrochureCoverImage = getMediaFilePath(courseData.courseBrochureCoverImage).url;
          courseData.courseHandbookCoverImage = getMediaFilePath(courseData.courseHandbookCoverImage).url;
          setCourse(courseData);
          setFellowAccess(courseData.allowFellowsAccess);
          console.log("Course Data:", response.result);
          
          // Find and set the module when course loads
          setCourseModule(
            response.result.moduleGroups
              ?.flatMap(group => group.modules)
              .find(mod => mod.courseModuleId === Number(moduleId)) || null
          );
        }

        setLoading(false);
    });

  }, [courseId]);

  const hasFellowAccess = fellowAccess && isFellow;

  useEffect(() => {
    console.log('allowfellowaccess:', fellowAccess);
    console.log('isFellow:', isFellow);
    console.log('hasfellowaccess:', hasFellowAccess);
  }, [fellowAccess, isFellow, hasFellowAccess]);

  useEffect(() => {
    if (course && course.moduleGroups) {
      const newModule = course.moduleGroups
        .flatMap(group => group.modules)
        .find(mod => mod.courseModuleId === Number(moduleId));
  
      if (newModule) {
        console.log("Updating courseModule:", newModule);
        setCourseModule(newModule);
      }
    }
  }, [moduleId, course]); // Runs every time moduleId changes  

  const insolLogo = getMediaFilePath("~/getmedia/4bae7ee4-2b36-49f4-be1c-e69b5796c8fd/insol-logo.svg").url + "?" + generateId();
  const signature1 = getMediaFilePath("~/getmedia/f7c38cc6-d90b-4866-a8ff-095e9160e06e/signature-1.jpg").url + "?" + generateId();
  const signature2 = getMediaFilePath("~/getmedia/6333382c-50f6-4047-9a32-180c3ae136bf/signature-2.jpg").url + "?" + generateId();

  const pdfExportComponent = useRef(null);
  
  const exportPDFWithComponent = () => {
      if (pdfExportComponent.current) {
          pdfExportComponent.current.save();
      }
  };

  if (loading || !course || (!courseStudent && !hasFellowAccess)) {
    return <div>Loading...</div>;
  }

  //const courseStartDate = new Date(course.courseStartDate);
  //const today = new Date();
  //if (!courseStudent.isEnrolled && today >= courseStartDate) {

  if (hasFellowAccess) {
    return (
      <div>
        {/* Hero */}
        <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
            <header className="section-header mt-auto mb-10">
              <h2 className="section-title text-4.5xl font-bold">{course.courseTitle}</h2>
            </header>
            {/* Breadcrumbs */}
            <div className="breadcrumbs mb-4 z-10">
              <ul className="flex">
                <li><Link className="white underline" to="/">Home</Link></li>
                <li className="breadcrumb-current">
                  <span className="breadcrumb-seperator mx-1">\</span><Link className="white underline" to="/education/v1">Education</Link>
                </li>
                <li className="breadcrumb-current">
                  <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{course.courseTitle}</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="flex absolute top-0 left-0 right-0 bottom-0 z-0">
            <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
          </div>
        </section>

        {/* My Courses */}
        <section className="courses py-8 lg:py-12">
              <div className="container flex flex-col h-full gap-12 mx-auto max-w-540 md:max-w-640 lg:flex-row lg:max-w-992 xl:max-w-90rem p-4">
                <aside className="flex flex-col relative lg:w-450">

                  <div className="flex flex-col relative mb-12">
                      <div className="w-full p-6 bg-brandDarkBlue">
                          <h2 className="section-title text-1xl text-white font-bold">Course content</h2>
                      </div>
                      <div className="bg-brandGrey">
                          {course.moduleGroups && course.moduleGroups.map((group, index) => {
                            const modulesToDisplay = group.modules;
                            return (
                              <Fragment key={index}>
                                {modulesToDisplay.length > 0 && modulesToDisplay.map((module, moduleIndex) => (
                                  <Link key={moduleIndex} to={`../course/${courseId}/module/${module.courseModuleId}`}>
                                  <ModuleCheckbox
                                      label={module.moduleName}
                                      type="checkbox"
                                      moduleId={module.courseModuleId}
                                      active={parseInt(moduleId) === module.courseModuleId}
                                      //status="passed"
                                  />
                                  </Link>
                                ))}
                              </Fragment>
                            );
                          })}
                      </div>
                  </div>
                  
                  <div className="flex flex-col relative mb-12">
                      <div className="w-full p-6 bg-brandDarkBlue">
                          <h2 className="section-title text-1xl text-white font-bold">Module documentation</h2>
                      </div>
                      <div className="pt-6 px-6 bg-brandGrey">
                          {courseModule?.documents.map((document, documentIndex) => (
                            <ModuleDocument
                              key={documentIndex}
                              name={document.file.filename}
                              type={document.file.fileExtension.replace('.', '')}
                              link={`https://insol.azureedge.net/cmsstorage/insol/media/education/${document.file.path.toLowerCase()}`}
                            />
                          ))}
                      </div>
                  </div>

                </aside>
                
                {courseModule && (
                  <div className="flex-1">
                    <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">{courseModule.moduleName}</h1>
                    <div className="module__introduction" dangerouslySetInnerHTML={{ __html: courseModule.moduleDescription }} />
                    {courseModule.videoURL && (
                      <div className="video__container">
                          <iframe src={`${courseModule.videoURL}?web_component=true&amp;seo=true`} allow="autoplay; fullscreen"
                          allowfullscreen
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowtransparency="true"
                          frameborder="0"
                          scrolling="no"
                          class="wistia_embed"
                          name="wistia_embed">
                          </iframe>
                      </div>
                    )}
                    {courseModule.canvaURL && (
                      <div className="video__container">
                        <iframe
                          src={`${courseModule.canvaURL}?embed`}
                          allow="fullscreen"
                          allowFullScreen
                          loading="lazy"
                          frameBorder="0"
                          className="canva_embed"
                        ></iframe>
                      </div>
                    )}
                  </div>
                )}

            </div>
        </section>
        
        {courseModule?.assessments?.length > 0 && (
          <section className="courses py-8 lg:py-12 bg-brandGrey">
              <div className="container flex flex-col h-full gap-12 mx-auto max-w-540 md:max-w-640 lg:flex-row lg:max-w-992 xl:max-w-90rem p-4">
                  <aside className="flex flex-col relative lg:w-450">

                    {courseModule.assessments.map((assessment, assessmentIndex) => (
                      <AssessmentDocument 
                        key={assessmentIndex}
                        assessment={assessment}
                        course={course}
                        courseStudent={courseStudent}
                        courseModuleId={courseModule.courseModuleId}
                        hasFellowAccess={hasFellowAccess}
                      />
                    ))}

                  </aside>

                  <div className="flex-1">
                    <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Module assessment</h1>
                    <div className="module__introduction text-brandMidBlue" dangerouslySetInnerHTML={{ __html: courseModule.assessmentInformation }} />
                  </div>
              </div>
          </section>
        )}

      </div>
    );
  };
  
  if (!courseStudent.isEnrolled) {
    return (
      <div>
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container relative z-10 flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="mt-auto mb-10">
            <h2 className="section-title text-4.5xl text-white font-bold">{course.courseTitle}</h2>
          </header>
          <div className="breadcrumbs mb-4 z-10">
            <ul className="flex">
              <li><Link className="white underline" to="/">Home</Link></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><Link className="white underline" to="/education/v1">Education</Link>
              </li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{course.courseTitle}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>
      <section className="courses py-8 lg:py-12">
        <div className="flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-760">
            <div className='h-full text-sm p-20 w-full bg-brandGrey'>
              <h2 className="text-xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Module</h2>
              <p className="text-brandMidBlue text-md mb-4">This module is not currently available.</p>
            </div>
        </div>
      </section>
      </div>
    )
  }

  const selectedModule = courseStudent.selectedModules.find(
    (selected) => selected.courseModuleId === courseModule?.courseModuleId
  );

  return (
    <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="section-header mt-auto mb-10">
            <h2 className="section-title text-4.5xl font-bold">{course.courseTitle}</h2>
          </header>
          {/* Breadcrumbs */}
          <div className="breadcrumbs mb-4 z-10">
            <ul className="flex">
              <li><Link className="white underline" to="/">Home</Link></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><Link className="white underline" to="/education/v1">Education</Link>
              </li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{course.courseTitle}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0 z-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>

      {/* My Courses */}
      <section className="courses py-8 lg:py-12">
            <div className="container flex flex-col h-full gap-12 mx-auto max-w-540 md:max-w-640 lg:flex-row lg:max-w-992 xl:max-w-90rem p-4">
              <aside className="flex flex-col relative lg:w-450">

                <div className="flex flex-col relative mb-12">
                    <div className="w-full p-6 bg-brandDarkBlue">
                        <h2 className="section-title text-1xl text-white font-bold">Course content</h2>
                    </div>
                    <div className="bg-brandGrey">
                        {course.moduleGroups && course.moduleGroups.map((group, index) => {
                          const modulesToDisplay = course.allModulesRequired 
                          ? group.modules 
                          : group.modules.filter(module => courseStudent.selectedModules.some(selected => selected.courseModuleId === module.courseModuleId));
                          return (
                            <Fragment key={index}>
                              {modulesToDisplay.length > 0 && modulesToDisplay.map((module, moduleIndex) => (
                                <Link key={moduleIndex} to={`../course/${courseId}/module/${module.courseModuleId}`}>
                                <ModuleCheckbox
                                    label={module.moduleName}
                                    type="checkbox"
                                    moduleId={module.courseModuleId}
                                    active={parseInt(moduleId) === module.courseModuleId}
                                    //status="passed"
                                />
                                </Link>
                              ))}
                            </Fragment>
                          );
                        })}
                    </div>
                </div>
                
                <div className="flex flex-col relative mb-12">
                    <div className="w-full p-6 bg-brandDarkBlue">
                        <h2 className="section-title text-1xl text-white font-bold">Module documentation</h2>
                    </div>
                    <div className="pt-6 px-6 bg-brandGrey">
                        {courseModule?.documents.map((document, documentIndex) => (
                          <ModuleDocument
                            key={documentIndex}
                            name={document.file.filename}
                            type={document.file.fileExtension.replace('.', '')}
                            link={`https://insol.azureedge.net/cmsstorage/insol/media/education/${document.file.path.toLowerCase()}`}
                          />
                        ))}
                    </div>
                </div>
                
                {selectedModule?.hasPassed && !course.allModulesRequired && (
                <div className="flex flex-col relative mb-12">
                    <div className="w-full p-6 bg-brandDarkBlue">
                        <h2 className="section-title text-1xl text-white font-bold">You have passed this module</h2>
                    </div>
                    <div className="pt-6 px-6 bg-brandGrey">
                      <button type="button" onClick={exportPDFWithComponent} className="text-brandMidBlue underline mb-6">
                          <div className="flex items-center">
                              <img src="https://insol.azureedge.net/cmsstorage/insol/media/education/icons/download.svg" className="h-[35px] mr-6" alt="Download Certificate" />
                              <span className="text-brandMidBlue underline">Download Certificate</span>
                          </div>
                      </button>
                      <div style={{ position: "absolute", left: "-9999px" }}>
                      <PDFExport ref={pdfExportComponent} paperSize="A4" scale={1} style={{ height: "842px" }}>
                              <div id="certificate-content" className="p-8">
                                  <div className="bg-white p-2 flex flex-1 flex-col justify-between border-8 border-brandCertBlue" style={{ height: "778px" }}>
                                      <div class="border-2 border-brandDarkRed p-8 flex flex-col justify-between" style={{ height: "745px" }}>
                                          <div className="flex justify-between mb-8">
                                              <div className="w-full flex items-center">
                                                  <img src={insolLogo} className='block' style={{ width: '200px', height: 'auto', objectFit: 'contain', maxHeight: '100%' }} />
                                              </div>
                                              <div className="w-full flex items-center">
                                                  <img src={course.courseLogo} className="block object-contain ml-auto" style={{ width: 'auto', height: '100px', objectFit: 'contain', maxHeight: '100%' }} />
                                              </div>
                                          </div>
                                          <div className='w-full flex-1 flex flex-col flex-wrap h-full'>
                                              <p className='w-full mx-auto text-brandDarkRed uppercase text-center font-bold text-md mb-6 ' style={{ textAlign: 'center' }}>{course.courseTitle}<br />Completion of Module</p>
                                              <div className="w-full text-brandCertBlue uppercase text-center font-bold text-sm mb-6">This is to certify that</div>
                                              <p className='w-full text-brandDarkRed text-center uppercase font-bold text-md mb-6'>{courseStudent.fullName}</p>
                                              <p className="w-full text-brandCertBlue uppercase text-center font-bold text-sm mb-6">has passed the following module</p>
                                              <p className='w-full text-brandDarkRed text-center uppercase font-bold text-md mb-6'>{courseModule.moduleName}</p>
                                          </div>
                                          <div>
                                              <div className="flex justify-between items-end">
                                                <div className="flex flex-col">
                                                      <img src={signature1} className='mx-auto object-contain' style={{ height: '50px', objectFit: 'contain', maxWidth: '140px' }} />
                                                      <span className="block w-48 h-0.5 bg-uidarker my-6"></span>
                                                      <span className="text-brandCertBlue text-sm uppercase font-bold">Brenda Bennett<br />Course Leader</span>
                                                  </div>
                                                  <div className="flex flex-col">
                                                        <img src={signature2} className='mx-auto object-contain' style={{ height: '50px', objectFit: 'contain', maxWidth: '140px' }} />
                                                      <span className="block w-48 h-0.5 bg-uidarker my-6"></span>
                                                      <span className="text-brandCertBlue text-sm uppercase font-bold">David Burdette<br />Head of Education</span>
                                                  </div>
                                              </div>
                                              <div className="text-brandDarkBlue text-xs text-right pt-6">{courseStudent.studentId}</div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </PDFExport>
                      </div>
                    </div>
                </div>
                )}

              </aside>
              
              {courseModule && (
                <div className="flex-1">
                  <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">{courseModule.moduleName}</h1>
                  <div className="module__introduction" dangerouslySetInnerHTML={{ __html: courseModule.moduleDescription }} />
                  {courseModule.videoURL && (
                    <div className="video__container">
                        <iframe src={`${courseModule.videoURL}?web_component=true&amp;seo=true`} allow="autoplay; fullscreen"
                        allowfullscreen
                        webkitallowfullscreen
                        mozallowfullscreen
                        allowtransparency="true"
                        frameborder="0"
                        scrolling="no"
                        class="wistia_embed"
                        name="wistia_embed">
                        </iframe>
                    </div>
                  )}
                  {courseModule.canvaURL && (
                    <div className="video__container">
                      <iframe
                        src={`${courseModule.canvaURL}?embed`}
                        allow="fullscreen"
                        allowFullScreen
                        loading="lazy"
                        frameBorder="0"
                        className="canva_embed"
                      ></iframe>
                    </div>
                  )}
                </div>
              )}

          </div>
      </section>
      
      {courseModule?.assessments?.length > 0 && (
        <section className="courses py-8 lg:py-12 bg-brandGrey">
            <div className="container flex flex-col h-full gap-12 mx-auto max-w-540 md:max-w-640 lg:flex-row lg:max-w-992 xl:max-w-90rem p-4">
                <aside className="flex flex-col relative lg:w-450">

                  {courseModule.assessments.map((assessment, assessmentIndex) => (
                    <AssessmentDocument 
                      key={assessmentIndex}
                      assessment={assessment}
                      course={course}
                      courseStudent={courseStudent}
                      courseModuleId={courseModule.courseModuleId}
                      hasFellowAccess={hasFellowAccess}
                    />
                  ))}

                </aside>

                <div className="flex-1">
                  <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Module assessment</h1>
                  <div className="module__introduction text-brandMidBlue" dangerouslySetInnerHTML={{ __html: courseModule.assessmentInformation }} />
                </div>
            </div>
        </section>
      )}

    </div>
  );
};

export default Module;